import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { UserManagerSettings } from 'oidc-client';
@Injectable({
  providedIn: 'root'
})
export class ConfigsLoaderService {
  private httpClient: HttpClient;
  private configs: Configs;
  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }
  get apiUrl() {
    return this.configs.apiUrl;
  }
  get auth(): UserManagerSettings {
    return this.configs.auth;
  }
  get applicationId() {
    return this.configs.applicationId;
  }
  get accessTokenType() {
    return this.configs.accessTokenType;
  }
  get cloudEmailKey() {
    return this.configs.cloudEmailKey;
  }
  // tslint:disable-next-line: no-any
  public async loadConfigs(): Promise<any> {
    return this.httpClient.get('app/configs.json').pipe(settings => settings)
      .toPromise()
      .then(settings => {
        this.configs = settings as Configs;
      });
  }
}
export interface Configs {
  apiUrl: string;
  applicationId: number;
  auth: UserManagerSettings;
  accessTokenType: string;
  cloudEmailKey: string;
}
